import { render } from "./Header.vue?vue&type=template&id=5f4ab5c4&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=5f4ab5c4&lang=scss&scoped=true"

import exportComponent from "/builds/web-primary/web-ask-review/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f4ab5c4"]])

export default __exports__